import { call, put, takeLatest } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import * as types from './actionTypes';
import { post } from '../../../helpers/api_helper';

// 🔵 Fetch Multilevel Approval
function* fetchMultilevelApprovalSaga(action) {
  const { unit_id } = action.payload;
  try {
    const formData = new FormData();
    formData.append('unit_id', unit_id);

    const response = yield call(post, process.env.REACT_APP_FETCH_MULTILEVEL_APPROVAL, formData);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to fetch multilevel approval!');
    }

    yield put({ type: types.FETCH_MULTILEVEL_APPROVAL_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while fetching multilevel approval!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.FETCH_MULTILEVEL_APPROVAL_FAILURE, payload: error });
  }
}

// 🟢 Save Multilevel Approval
function* saveMultilevelApprovalSaga(action) {
  try {

    const response = yield call(post, process.env.REACT_APP_SAVE_MULTILEVEL_APPROVAL, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to save multilevel approval!');
    }

    Swal.fire({
      title: 'Success',
      text: response?.message,
      icon: 'success',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.SAVE_MULTILEVEL_APPROVAL_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while saving multilevel approval!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.SAVE_MULTILEVEL_APPROVAL_FAILURE, payload: error });
  }
}

function* toggleApprovalStatusSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_MULTILEVEL_APPROVAL, action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to update approval status!");
    }

    yield put({ type: types.TOGGLE_APPROVAL_STATUS_SUCCESS, payload: response });

    Swal.fire({
      title: "Success",
      text: "Status updated successfully!",
      icon: "success",
      timer: 2000,
      showConfirmButton: false,
    });
    
    // Optional: you can refetch the list or trigger a refresh here
  } catch (error) {
    yield put({ type: types.TOGGLE_APPROVAL_STATUS_FAILURE, payload: error });

    Swal.fire({
      title: "Error",
      text: error.message || "Something went wrong while updating status!",
      icon: "error",
      confirmButtonText: "OK",
    });
  }
}

// Watcher Saga
export default function* multilevelApprovalSaga() {
  yield takeLatest(types.FETCH_MULTILEVEL_APPROVAL_REQUEST, fetchMultilevelApprovalSaga);
  yield takeLatest(types.SAVE_MULTILEVEL_APPROVAL_REQUEST, saveMultilevelApprovalSaga);
  yield takeLatest(types.TOGGLE_APPROVAL_STATUS_REQUEST, toggleApprovalStatusSaga);
}
